import { render, staticRenderFns } from "./ShareStatus.vue?vue&type=template&id=4f734390&"
import script from "./ShareStatus.vue?vue&type=script&lang=js&"
export * from "./ShareStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ShareStatus.vue"
export default component.exports